import React from "react";
import cookie from "react-cookies";
import { styled } from "@mui/material/styles";
import { Button, Menu, MenuItem } from "@mui/material";
import { ReactComponent as MenuIcon } from "icons/menu-bar.svg";
import { logout } from "utils/wallet";
import { useNavigate } from "react-router-dom";

const CustomMenuItem = styled(MenuItem)({
  fontFamily: "Open Sans",
});

const ProfileMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const navigate = useNavigate();

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleHome = () => {
    navigate("/");
    handleClose();
  };
  const handleDashboard = () => {
    navigate("/dashboard");
    handleClose();
  };
  const handleOrganization = () => {
    if (cookie.load("user")?.organization.toLowerCase() === "gyde")
      navigate(`/organization/${cookie.load("user")?.organization}`);
    handleClose();
  };
  const handleProfile = () => {
    navigate(`/profile/${cookie.load("user")?.tokenId}`);
    handleClose();
  };
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    cookie.remove("user");
    logout();
    navigate("/");
    handleClose();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MenuIcon className="w-16 h-8 fill-[#fff]" />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <CustomMenuItem onClick={handleHome}>Home</CustomMenuItem>
        {(cookie.load("user").userType === "admin" ||
          cookie.load("user").userType === "admin") && (
          <CustomMenuItem onClick={handleDashboard}>Dashboard</CustomMenuItem>
        )}
        {(cookie.load("user")?.userType !== "user" ||
          cookie.load("user")?.organization.toLowerCase() !== "gyde") && (
          <CustomMenuItem onClick={handleOrganization}>
            {cookie.load("user")?.organization}
          </CustomMenuItem>
        )}
        {cookie.load("user")?.organization.toLowerCase() === "gyde" && (
          <CustomMenuItem onClick={handleProfile}>My Profile</CustomMenuItem>
        )}
        <CustomMenuItem onClick={handleLogout}>Logout</CustomMenuItem>
      </Menu>
    </div>
  );
};

export default ProfileMenu;
